import { AxiosResponse } from "axios";

export function AxiosResponseInterceptor(response: AxiosResponse) {
	return response.data;
}
